var option_webview_default = {
  "option": "U6Mr4",
  "user_choice": "I5P1-",
  "check": "qx3fs",
  "image": "M3i6o",
  "input": "r5t8t",
  "title": "_58cPy",
  "centered": "HKYSj",
  "with_result": "_3asDq",
  "list": "LUoz8",
  "with_image": "Na9uK",
  "progress": "t-yPt",
  "progress_value": "z6bWC",
  "label": "_9dMr1",
  "cta": "_8NEMl",
  "adornment_icon": "cLSzT",
  "remove": "-gs3e",
  "removeButton": "SJq0u",
  "removeButtonIcon": "VzvHH",
  "overlay": "_0PmDF",
  "shown": "I-B-B",
  "dark": "APkJx",
  "spinner": "igbB-",
  "spin": "aAZLX",
  "grid": "_5GiVQ"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
